<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"> </p>
<p class="p1">. . . He must be the best man in his world and a good enough man for any world. . . .</p>
<p class="p1">He is a lonely man and his pride is that you will treat him as a proud man or be very sorry you ever saw him. He talks as the man of his age talks—that is, with rude wit, a lively sense of the grotesque, a disgust for sham, and a contempt for pettiness.</p>
<p class="p5">—Raymond Chandler</p>
<p class="p5">“The Simple Art of Murder”</p>
<p class="p6"> </p>
<p class="p1">When you’re lost in the rain in Juarez and it’s Eastertime too</p>
<p class="p1">And your gravity fails and negativity don’t pull you through</p>
<p class="p1">Don’t put on any airs when you’re down on Rue Morgue Avenue</p>
<p class="p1">They got some hungry women there and they really make a mess out of you.</p>
<p class="p5">—Bob Dylan</p>
<p class="p5"><i>Just Like Tom Thumb’s Blues</i></p>
<p class="p3"> </p>
<p class="p3"> </p>
<p class="p3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?0f8fbc25